import type { AgentMode } from "@/types/aiChat";

export const CADDIE_NAME = "Caddie";
export const CADDIE_AI_NAME = "Caddie AI Assistant";
export const ASK_CADDIE_LABEL = "Ask Caddie";
export const BUILD_WITH_CADDIE_LABEL = "Ask Caddie";
export const FIX_WITH_CADDIE_LABEL = "Fix with Caddie";

export type CaddieMood = "default" | "planning" | "building" | "repair" | "conversation" | "success";

type CaddieModeConfig = {
  asset: string;
  label: string;
  mood: CaddieMood;
  imageClassName: string;
};

const MODE_CONFIG: Record<AgentMode, CaddieModeConfig> = {
  planning: {
    asset: "/caddie/caddie-question.svg",
    label: "Plan Mode",
    mood: "planning",
    imageClassName: "object-contain p-[10%]",
  },
  building: {
    asset: "/caddie/caddie-default.svg",
    label: "Build Mode",
    mood: "building",
    imageClassName: "object-cover p-[10%]",
  },
  repair: {
    asset: "/caddie/caddie-frown.svg",
    label: "Repair Mode",
    mood: "repair",
    imageClassName: "object-contain p-[10%]",
  },
  conversation: {
    asset: "/caddie/caddie-smirk.svg",
    label: "Chat Mode",
    mood: "conversation",
    imageClassName: "object-contain p-[10%]",
  },
};

const MOOD_CONFIG: Record<CaddieMood, CaddieModeConfig> = {
  default: {
    asset: "/caddie/caddie-default.svg",
    label: CADDIE_AI_NAME,
    mood: "default",
    imageClassName: "object-contain p-[10%]",
  },
  planning: MODE_CONFIG.planning,
  building: MODE_CONFIG.building,
  repair: MODE_CONFIG.repair,
  conversation: MODE_CONFIG.conversation,
  success: {
    asset: "/caddie/caddie-thumbs-up.svg",
    label: "Ready",
    mood: "success",
    imageClassName: "object-contain p-[10%]",
  },
};

export function getCaddieModeConfig(mode: AgentMode): CaddieModeConfig {
  return MODE_CONFIG[mode];
}

export function getCaddieMoodConfig(mood: CaddieMood): CaddieModeConfig {
  return MOOD_CONFIG[mood];
}
